// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"l3-z","colorTextValue":"m3-z","swatches":"n3-z","collapseLink":"o3-z","isCollapsed":"p3-z","dropdown":"q3-z","disabled":"r3-z"};